<script lang="ts">
import { page } from "$app/state";
import { chromeOf } from "./copy/chrome";
import { LOCALE_INFO, LOCALES, splitLocale } from "./locales";
import { switchTarget } from "./registry";

// The one way this site changes language: a list of plain links the visitor
// chooses from. Nothing is inferred from the browser's language or from where
// the request came from, so a reader is never moved away from the page they
// asked for.
//
// Each link goes to the same page in the chosen language when it exists there,
// and to that language's home when it does not. A `<details>` element rather
// than a scripted menu, because most of the pages it sits on ship no script at
// all, and a switcher that needed one would be a dead control on them.
//
// The links reload the document rather than going through the client router:
// the language and the writing direction are attributes of the `<html>`
// element, which the server writes, and a reload is what hands the new page a
// document written for its language.

const located = $derived(splitLocale(page.url.pathname));
const label = $derived(chromeOf(page.data).language.label);
</script>

<nav
  aria-label={label}
  data-testid="language-switcher"
  class="px-6 pb-4 text-[13px] leading-5 text-slate-500"
>
  <details>
    <summary class="tap-target-inline cursor-pointer select-none hover:text-slate-900">
      <span aria-hidden="true">🌐</span>
      {label}: <span lang={LOCALE_INFO[located.locale].lang}>{LOCALE_INFO[located.locale].nativeName}</span>
    </summary>
    <ul class="mt-2 flex flex-wrap gap-x-4 gap-y-2">
      {#each LOCALES as locale (locale)}
        <li>
          <a
            href={switchTarget(located.path, locale)}
            hreflang={LOCALE_INFO[locale].lang}
            lang={LOCALE_INFO[locale].lang}
            data-sveltekit-reload
            data-testid="language-{locale}"
            data-analytics-id="language.switch.{locale}"
            aria-current={locale === located.locale ? "true" : undefined}
            class="tap-target-inline hover:text-slate-900 hover:underline {locale === located.locale
              ? 'font-semibold text-slate-900'
              : ''}"
          >
            {LOCALE_INFO[locale].nativeName}
          </a>
        </li>
      {/each}
    </ul>
  </details>
</nav>
